import {FC} from 'react'

/**
 * LegacyTryNextCard — the "Try the new version" affordance for the FROZEN legacy
 * React (CRA/Metronic) admin portal. Rendered at the BOTTOM of the classic navy
 * aside rail (see AsideDefault.tsx), below the scrollable menu.
 *
 * Design authority: _bmad-output/design/version-switch/variant-b.html, RIGHT column
 * ("Classic portal") — a contained blue card in the classic app's own visual language
 * (#009ef7 primary on the #1e1e2d rail): sparkle icon, "Try the new version" label,
 * solid blue "Beta" pill. NO emoji; inline stroke SVG only.
 *
 * The link is a PLAIN full-page navigation to `/next/` (the Angular portal is a
 * separate app served at that path) — deliberately NOT a react-router <Link>.
 * Self-contained: scoped styles live in the <style> block below (class prefix
 * `legacy-try-next-`); nothing else in the frozen app is touched.
 */
const LegacyTryNextCard: FC = () => {
  return (
    // id kt_aside_footer + aside-footer: Metronic's aside scroll calc subtracts the
    // heights of its declared dependencies ('#kt_aside_logo, #kt_aside_footer' on
    // #kt_aside_menu). Without this id the menu claims the full viewport and pushes
    // this card below the fold. REPAIRED 2026-07-22 (found in local-pair testing).
    <div id='kt_aside_footer' className='aside-footer flex-column-auto legacy-try-next'>
      <style>{`
        .legacy-try-next {
          flex-shrink: 0;
          margin-top: auto;
          padding: 12px 8px 16px;
        }
        .legacy-try-next-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          text-align: center;
          padding: 12px 6px;
          border-radius: 10px;
          text-decoration: none;
          background: linear-gradient(180deg, rgba(0, 158, 247, 0.18), rgba(0, 158, 247, 0.08));
          border: 1px solid rgba(0, 158, 247, 0.45);
          transition: background 0.15s ease, border-color 0.15s ease;
        }
        .legacy-try-next-card:hover {
          background: linear-gradient(180deg, rgba(0, 158, 247, 0.28), rgba(0, 158, 247, 0.12));
          border-color: rgba(0, 158, 247, 0.7);
        }
        .legacy-try-next-card .lt-ico {
          width: 24px;
          height: 24px;
          stroke: #4db8fb;
          fill: none;
          stroke-width: 1.6;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
        .legacy-try-next-card .lt-t {
          font-size: 10.5px;
          font-weight: 700;
          color: #eaf5ff;
          line-height: 1.2;
        }
        .legacy-try-next-card .lt-beta {
          font-size: 8px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #fff;
          background: #009ef7;
          padding: 1px 7px;
          border-radius: 999px;
        }
      `}</style>
      <a className='legacy-try-next-card' href='/next/'>
        <svg className='lt-ico' viewBox='0 0 24 24'>
          <path d='M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6z' />
          <path d='M18 15l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z' />
        </svg>
        <span className='lt-t'>Try the new version</span>
        <span className='lt-beta'>Beta</span>
      </a>
    </div>
  )
}

export {LegacyTryNextCard}
